/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { ClientPersonExtended, ClientPersonOwn } from '@DigitaleDoerfer/digitale-doerfer-api';
import { Grid, Link } from '@mui/material';
import { ReadOnlyTextFieldView } from '../ReadOnlyTextField.view';

interface Props {
	person: ClientPersonOwn | ClientPersonExtended;
	showMoreDetails: boolean;
	handleMoreDetailsLink: () => void;
}

function ExpandablePersonDetailFormView(props: Props): JSX.Element | null {
	const { person, handleMoreDetailsLink, showMoreDetails } = props;
	const street = person.address && person.address.street ? person.address.street : '';
	const { city, zip } = person.address ? person.address : { city: '', zip: '' };

	let zipAndCity = '';
	if (zip && city) {
		zipAndCity = `${zip} ${city}`;
	} else if (zip) {
		zipAndCity = zip;
	} else if (city) {
		zipAndCity = city;
	}

	if (showMoreDetails) {
		return (
			<>
				<Grid item xs={12} md={6}>
					<ReadOnlyTextFieldView
						id="zipAndCity"
						name="zipAndCity"
						label="Wohnort"
						value={zipAndCity}
						InputProps={{ readOnly: true }}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<ReadOnlyTextFieldView
						id="street"
						name="street"
						label="Straße"
						value={street || ''}
						InputProps={{ readOnly: true }}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<ReadOnlyTextFieldView
						id="phoneNumber"
						name="phoneNumber"
						label="Telefonnummer"
						value={person.phoneNumber || ''}
						InputProps={{ readOnly: true }}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<ReadOnlyTextFieldView
						id="nickName"
						name="nickName"
						label="Alias"
						value={person.nickName || ''}
						InputProps={{ readOnly: true }}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
					/>
				</Grid>
			</>
		);
	} else {
		if (zipAndCity || street || person.nickName || person.phoneNumber) {
			// Render mehr link
			return (
				<Grid item xs={12} hidden={showMoreDetails}>
					<Link href="#" onClick={handleMoreDetailsLink}>
						mehr
					</Link>
				</Grid>
			);
		}
	}

	return <></>;
}

export default ExpandablePersonDetailFormView;
